import { ReportParamsTransformer } from '@content-platform/web-angular-shared-util-error-handling';
import { ApplicationApiConstants } from '../application-api-config';
export class AppReportParamsTransformer extends ReportParamsTransformer {
    constructor(injector) {
        super(injector);
    }
    getParams() {
        return {
            Application: ApplicationApiConstants.activeAppName
        };
    }
}
//# sourceMappingURL=report-params-transformer.js.map